import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { fetchApi } from "../../../helper/api";
import { useEffect, useState } from "react";
import { IsAlert } from "../../atoms/IsAlert";

const EditRole = (props) => {
  const navigate = useNavigate();
  const [values, setValues] = useState(null);
  useEffect(() => {
    // console.log(props);
    setValues(props.dataEdit);
  }, [props]);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleSubmit = async () => {
    try {
      //   console.log("Val", values);
      const body = {
        desc: values.desc,
        nameRole: values.namaRole,
        roleId: values.roleId.toString(),
      };
      const req = await fetchApi("api/Role", "PUT", true, body);
      const status = req.status;
      const res = await req.json();
      if (status !== 200) throw res;
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.log("ERROR", error);
      IsAlert.fire({
        title: "Sorry!",
        text: "There is an error",
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      });
    }
  };

  //   console.log("data edit role", props.dataEdit);

  if (props.dataEdit?.namaRole && props.dataEdit?.desc) {
    //   console.log("MASUK", values);
    return (
      <div
        className="modal fade"
        id="EditRole_modal"
        tabIndex={-1}
        aria-labelledby="EditRole_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h5 className="mb-0 ml-2">Edit Role</h5>
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-2">
                <label>Nama Hak Akses</label>
                <h6>
                  <b>{props.dataEdit?.namaRole}</b>
                </h6>
              </div>
              <TextField
                onChange={handleChange("desc")}
                value={values?.desc}
                className="w-100"
                label="Deskripsi Role"
                autoComplete="off"
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSubmit}
              >
                Simpan
              </button>
              <button
                type="button"
                className="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return "";
};
export default EditRole;
